import { requestJson } from "recipal-app/controllers/shared/requests.js";
import {
  autofillLotCodesShipmentShipmentItemsPath,
  shipmentShipmentItemPath,
  shipmentShipmentItemsPath,
} from "~/routes.js";

export const createShipmentItem = (shipmentId, shipmentItem) =>
  requestJson(shipmentShipmentItemsPath(shipmentId), {
    method: "POST",
    body: JSON.stringify({ shipment_item: shipmentItem }),
  });

export const updateShipmentItem = (shipmentId, itemId, shipmentItem) =>
  requestJson(shipmentShipmentItemPath(shipmentId, itemId), {
    method: "PATCH",
    body: JSON.stringify({ shipment_item: shipmentItem }),
  });

export const deleteShipmentItem = (shipmentId, itemId) =>
  requestJson(shipmentShipmentItemPath(shipmentId, itemId), {
    method: "DELETE",
  });

export const autofillShipmentLotCodes = (shipmentId) =>
  requestJson(autofillLotCodesShipmentShipmentItemsPath(shipmentId), {
    method: "POST",
  });
